import { Component, OnInit, Optional, Input } from '@angular/core';
import { PaymentService } from '../services/payment.service';
import { environment } from '../../environments/environment';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import * as constants from '../constants';
import { combineLatest, map, Observable } from 'rxjs';

const PRODUCT_NAME = `FlowStudio`;

@Component({
    selector: 'app-subscription-payment',
    templateUrl: './subscription-payment.component.html',
    styleUrls: ['./subscription-payment.component.scss'],
    standalone: false
})
export class SubscriptionPaymentComponent implements OnInit {

  handler: any;
  product: string;
  token: any;
  error: any;
  @Input() promotion = false;
  @Input() coupon = null;
  @Input() couponText = '';
  @Input() discount = 0;

  yearly = constants.pro_yearly;
  yearlyDiscount = 40;
  amount = 0;
  constants = constants;

  public product_yearly = false;
  public membership$: Observable<any>;
  public licenseHasTeams$: Observable<boolean>;  
  public portal$: Observable<string>;

  constructor(
    private paymentService: PaymentService,
    private gtm: Angulartics2GoogleTagManager,
    @Optional() public dialogRef: DialogRef) {

      this.membership$ = this.paymentService.membership$;
      this.licenseHasTeams$ = this.paymentService.licenseHasTeams$;
      this.portal$ = this.paymentService.portal$;
      
  }

  ngOnInit() {
    this.configHandler();
    this.gtm.pushLayer({
      'event': 'view_item',
      'items': [
        {'item_name': 'Monthly'},
        {'item_name': 'Yearly'}
      ]
    });

  }

  private configHandler(): any {
    this.paymentService.verify(true, true);
    this.handler = (<any>window).StripeCheckout.configure({
      key: environment.stripeKey,
      locale: "auto",
      token: token => {
        this.processPayment(token, this.product, this.amount, this.coupon);
      }
    });
  }

  isLocal() {
    return true;
    //return window.location.hostname == "localhost";
  }

  openCoffeeHandler() {
    this.product = "One-Time";
    this.amount = 500;
    this.handler.open({
      email: this.paymentService.userId,
      name: PRODUCT_NAME,
      image: "/assets/flow-studio-logo-90.png",
      zipCode: true,
      description: "Buy the dev a coffee one time.",
      amount: this.amount
    })
  }

  openTeamsHandler() {
    this.product = this.product_yearly ? "Teams-Yearly" : "Teams-Monthly";
    this.amount = (this.product_yearly ? constants.teams_yearly : constants.teams_monthly) * 100;
    this.gtm.pushLayer({
      'event': 'begin_checkout',
      'currency': 'USD',
      'value': this.amount,
      'coupon': this.coupon,
      'items': [
        {'item_name': this.product}
      ] 
    });

    this.handler.open({
      email: this.paymentService.userId,
      name: PRODUCT_NAME,
      image: "/assets/flow-studio-logo-90.png",
      zipCode: true,
      description: this.product_yearly ? "Yearly Subscription US$1000 / Year" : "Monthly Subscription US$100 / Month",
      amount: this.amount
    })
  }

  openProHandler() {
    this.product = this.product_yearly ? "Yearly" : "Monthly";
    this.amount = (this.product_yearly ? constants.pro_yearly : constants.pro_monthly) * 100;
    this.gtm.pushLayer({
      'event': 'begin_checkout',
      'currency': 'USD',
      'value': this.amount,
      'coupon': this.coupon,
      'items': [
        {'item_name': this.product}
      ] 
    });

    this.handler.open({
      email: this.paymentService.userId,
      name: PRODUCT_NAME,
      image: "/assets/flow-studio-logo-90.png",
      zipCode: true,
      description: this.product_yearly ? "Yearly Subscription US$250 / Year" : "Monthly Subscription US$25 / Month",
      amount: this.amount
    })
  }

  openMonthHandler() {
    this.product = "Monthly";
    this.amount = 2000;
    this.gtm.pushLayer({
      'event': 'begin_checkout',
      'currency': 'USD',
      'value': this.amount,
      'coupon': this.coupon,
      'items': [
        {'item_name': this.product}
      ] 
    });

    this.handler.open({
      email: this.paymentService.userId,
      name: PRODUCT_NAME,
      image: "/assets/flow-studio-logo-90.png",
      zipCode: true,
      description: "Monthly Subscription US$20 / Month",
      amount: this.amount
    })
  }

  openYearHandler() {
    this.product = "Yearly";
    this.amount = (20000 + (this.discount* 100));

    let config = {
      email: this.paymentService.userId,
      name: PRODUCT_NAME,
      image: "/assets/flow-studio-logo-90.png",
      zipCode: true,
      description: `Yearly Subscription US$${(200 + (this.discount))} / Year`,
      //panelLabel: "First year {{amount}}",
      panelLabel: '',
      amount: this.amount
    };

    if (this.coupon) {
      config.panelLabel = `${this.coupon} ${this.couponText}`
    }

    this.gtm.pushLayer({
      'event': 'begin_checkout',
      'currency': 'USD',
      'value': this.amount,
      'coupon': this.coupon,
      'items': [
        {'item_name': this.product}
      ] 
    });

    this.handler.open(config);
  }

  openUpdateHandler() {
    this.product = "Update"

    let config = {
      email: this.paymentService.userId,
      name: PRODUCT_NAME,
      image: "/assets/flow-studio-logo-90.png",
      zipCode: true,
      description: `Update Card Details`,
      //panelLabel: "First year {{amount}}",
      panelLabel: 'Update Card Details',
      //amount: (20000 + (this.discount* 100))
    };

    if (this.coupon) {
      config.panelLabel = `${this.coupon} ${this.couponText}`
    }

    this.handler.open(config);
  }

  processPayment(token, product, amount, coupon = null) {
    var success = false;

    this.gtm.pushLayer({
      'event': 'purchase',
      'currency': 'USD',
      'value': amount,
      "transaction_id": `${token.id}`,
      'coupon': coupon,
      'items': [
        {'item_name': product}
      ] 
    });

    this.paymentService.processPayment(token, product, coupon).catch((reason) => {
      this.token = token;
      this.error = reason;
    });
  }

  retry() {
    this.processPayment(this.token, this.product, this.amount, this.coupon);
  }

  close() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

}
